import { freeUserUpgradeStep } from '../utils';

export const settingsNpoTour = {
  tourKey: 'settings_npo',
  conditions: {
    orgTypes: ['npo'],
    userTypes: ['admin'],
    plans: null,
  },
  steps: [
    {
      target: '[data-tour="business-profile"]',
      title: 'tours.settings-business.welcome.title',
      content: 'tours.settings-npo.welcome.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="settings-tab"]',
      title: 'tours.settings-business.settings-tab.title',
      content: 'tours.settings-business.settings-tab.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="general-section"]',
      title: 'tours.account-settings-npo.general-info.title',
      content: 'tours.settings-npo.general-info.content',
      placement: 'top',
    },
    {
      target: '[data-tour="rescue-settings-section"]',
      autoOpenSelector: '[data-tour="settings-tab"]',
      title: 'tours.settings-npo.rescue-settings.title',
      content: 'tours.settings-npo.rescue-settings.content',
      placement: 'top',
    },
    freeUserUpgradeStep,
  ],
};
